import { render, staticRenderFns } from "./AdditionalQsDialog.vue?vue&type=template&id=520e473e&scoped=true"
import script from "./AdditionalQsDialog.vue?vue&type=script&lang=js"
export * from "./AdditionalQsDialog.vue?vue&type=script&lang=js"
import style0 from "./AdditionalQsDialog.vue?vue&type=style&index=0&id=520e473e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520e473e",
  null
  
)

export default component.exports